import Container from 'components/common/Container'
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Bg3 from "assets/main/bg3.avif";
import { ReactComponent as Logo } from 'assets/main/sixthLogo.svg'

const Sixth = () => {
    const tags = ['AI 서포트', '리스크관리', '서류처리', '3D 적재']

    return (
        <div
            className='flex justify-center items-center gap-6 h-[640px]'
            style={{ background: `url(${Bg3}) center/cover no-repeat` }}
        >
            <Container className='flex flex-col gap-10'>
                <div>
                    <motion.div
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY}
                        className='font-bold text-40'
                    >
                        물류 리스크 & 설계 관리는
                    </motion.div>
                    <motion.div
                        transition={{ delay: 0.1 }}
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY}
                        className='flex items-center gap-3 font-bold text-40'
                    >
                        <Logo /> 과 함께!
                    </motion.div>
                </div>
                <motion.p
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='text-lg'
                >
                    해외 물류 서류 준비부터 3D 적재 및 설계 · 위험 대응까지<br />
                    헤매지말고 꼼꼼하게 AI 서포트를 받아보세요!
                </motion.p>

                <div className='flex items-center gap-3 font-semibold text-lg'>
                    {
                        tags.map((item, idx) => (
                            <motion.div
                                key={idx}
                                transition={{ delay: 0.1 * idx + 0.3 }}
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}
                                className='flex justify-center items-center bg-[#DEF2E9] px-7.5 py-2.5 rounded-full'
                            >
                                # {item}
                            </motion.div>
                        ))
                    }
                </div>
            </Container>
        </div>
    )
}

export default Sixth